class DescriptionToggle {
  constructor() {
    this.initToggle();
  }

  initToggle() {
    const descriptionWrappers = document.querySelectorAll('[data-description-content]');
    
    descriptionWrappers.forEach((content) => {
      const button = content.parentElement.querySelector('[data-read-more-btn]');
      
      if (!button) return;

      // Check if content needs toggle (if it's taller than collapsed height)
      const fullHeight = content.scrollHeight;
      const collapsedHeight = 120; // Match CSS max-height value

      if (fullHeight <= collapsedHeight) {
        button.style.display = 'none';
        content.classList.remove('phi--collapsed');
        return;
      }

      button.addEventListener('click', () => {
        const isCollapsed = content.classList.contains('phi--collapsed');
        const readMoreText = button.querySelector('.phi--read-more-text');
        const readLessText = button.querySelector('.phi--read-less-text');

        if (isCollapsed) {
          // Expand
          content.classList.remove('phi--collapsed');
          content.classList.add('phi--expanded');
          readMoreText.style.display = 'none';
          readLessText.style.display = 'inline';
        } else {
          // Collapse
          content.classList.remove('phi--expanded');
          content.classList.add('phi--collapsed');
          readMoreText.style.display = 'inline';
          readLessText.style.display = 'none';
          
          // Scroll back to description if user scrolled down
          content.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        }
      });
    });
  }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => new DescriptionToggle());
} else {
  new DescriptionToggle();
}